// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_27qs-Am5uk","pin":"_3Pyoc90kRe"};